import React from 'react'
import List from './List'
import { useContractPositionCountsById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const counts = useContractPositionCountsById(id)
  return (
    <List counts={counts} />
  )
}

export default Body
